/*
 *
 * RecoveryAttemptsExceededModal
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 17-Oct-2024
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import RecoveryAttemptsExceededModal from './RecoveryAttemptsExceededModal'
import { doHidePopup } from 'Store/actions/popup'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ doHidePopup }, dispatch)
})

const mapStateToProps = () => ({

})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(RecoveryAttemptsExceededModal)
